// extracted by mini-css-extract-plugin
export var lg = "_16-4";
export var md = "_16-3";
export var sm = "_16-2";
export var xs = "_16-1";
export var xxs = "_16-0";